export default __webpack_public_path__ + "static/media/zx7-on-table.691259cd.png";